import { render, staticRenderFns } from "./Paramdrpdwn.vue?vue&type=template&id=1c0fa508&"
import script from "./Paramdrpdwn.vue?vue&type=script&lang=js&"
export * from "./Paramdrpdwn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports